
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { google } from 'google-maps';
import MissionStore from '../../store/modules/missions';
import { getModule } from 'vuex-module-decorators';
import RenderColors from '@/flightpath-components/services/colors';
import { RenderHelper } from '@/services/RenderHelper';

@Component
export default class GoogleMapPolygon extends Vue {
  @Prop() googleApi!: google;
  @Prop() map!: google.maps.Map<HTMLDivElement>;
  @Prop() polygon!: google.maps.PolygonOptions;

  mapPolygon = null as google.maps.Polygon | null;
  missionStore = getModule(MissionStore, this.$store);

  destroyed() {
    this.mapPolygon?.setMap(null);
  }

  mounted() {
    this.mapPolygon = new this.googleApi.maps.Polygon({
      paths: this.polygon.paths,
      fillColor: this.polygon.fillColor,
      fillOpacity: this.polygon.fillOpacity,
      map: this.map,
      strokeColor: this.polygon.strokeColor,
      strokeOpacity: this.polygon.strokeOpacity,
      visible: this.polygon.visible
    });

    this.updateMapAndArea();
  }

  @Watch('polygon')
  onShapeChange() {
    const newPath = this.polygon.paths?.pop() as Array<google.maps.LatLng>;

    if (this.mapPolygon && newPath) {
      this.mapPolygon.setPath(newPath);
      this.mapPolygon.setVisible(true);
    }

    this.updateMapAndArea();
  }

  updateMapAndArea() {
    if (this.polygon.strokeColor == RenderColors.Field) {
      this.missionStore.setFieldAreaM2(this.findFieldArea());
      if (this.mapPolygon?.getPath() != undefined) {
        this.map.fitBounds(RenderHelper.getBounds(this.mapPolygon.getPath()));
      }
    }
    if (this.polygon.fillColor == RenderColors.WorkArea) {
      this.missionStore.setWorkAreaAreaM2(this.findFieldArea());
    }
  }

  findFieldArea() {
    return this.mapPolygon == undefined ? 0 : Math.round(this.googleApi.maps.geometry.spherical.computeArea(this.mapPolygon.getPath()));
  }
}
